<template>
    <!-- 버튼 라우터 : ( 나누리충전 / 상품권교환소 / 모바일도서교환권 / 캐시내역 ) -->
    <v-row no-gutters class="main-button-group text-center white--text">
        <v-col cols="6" md="3" data-aos="fade-up" data-aos-duration="600">
            <v-btn x-large block :height="$vuetify.breakpoint.mobile ? 80 : 80" color="#181d62" to="/mypage/cashes/charge" class="main-button-group__btn">
                <v-row no-gutters align="center" justify="center">
                    <v-col cols="12" md="auto">
                        <v-img width="42" height="39" src="/images/main/icon1.svg" contain class="mx-auto" />
                    </v-col>
                    <v-col cols="12" md="auto">
                        <span class="font-size-14 font-size-md-18 mt-4px mt-md-0 ml-md-10px">나누리 충전</span>
                    </v-col>
                </v-row>
            </v-btn>
        </v-col>
        <v-col cols="6" md="3" data-aos="fade-up" data-aos-duration="600" data-aos-delay="100">
            <v-btn v-if="!$vuetify.breakpoint.mobile" x-large block :height="$vuetify.breakpoint.mobile ? 80 : 80" color="#22298b" to="/gshop/brand?_category&page=1" class="main-button-group__btn">
                <v-row no-gutters align="center" justify="center">
                    <v-col cols="12" md="auto">
                        <v-img width="42" height="39" src="/images/main/icon2.svg" contain class="mx-auto" />
                    </v-col>
                    <v-col cols="12" md="auto">
                        <span class="font-size-14 font-size-md-18 mt-4px mt-md-0 ml-md-10px">상품권 교환소</span>
                    </v-col>
                </v-row>
            </v-btn>
            <v-btn v-if="$vuetify.breakpoint.mobile" x-large block :height="$vuetify.breakpoint.mobile ? 80 : 80" color="#22298b" to="/gshop/brand?_category&page=1" class="main-button-group__btn">
                <v-row no-gutters align="center" justify="center">
                    <v-col cols="12" md="auto">
                        <v-img width="42" height="39" src="/images/main/icon2.svg" contain class="mx-auto" />
                    </v-col>
                    <v-col cols="12" md="auto">
                        <span class="font-size-14 font-size-md-18 mt-4px mt-md-0 ml-md-10px">상품권 교환소</span>
                    </v-col>
                </v-row>
            </v-btn>
        </v-col>
        <v-col cols="6" md="3" data-aos="fade-up" data-aos-duration="600" data-aos-delay="150">
            <v-btn x-large block :height="$vuetify.breakpoint.mobile ? 80 : 80" color="#2c4fb4" to="/shop/exchange" class="main-button-group__btn">
                <v-row no-gutters align="center" justify="center">
                    <v-col cols="12" md="auto">
                        <v-img width="42" height="39" src="/images/main/icon3.svg" contain class="mx-auto" />
                    </v-col>
                    <v-col cols="12" md="auto">
                        <span class="font-size-14 font-size-md-18 mt-4px mt-md-0 ml-md-10px">모바일 도서 교환권</span>
                    </v-col>
                </v-row>
            </v-btn>
        </v-col>
        <v-col cols="6" md="3" data-aos="fade-up" data-aos-duration="600" data-aos-delay="200">
            <v-btn x-large block :height="$vuetify.breakpoint.mobile ? 80 : 80" color="#366fd7" to="/mypage/cashes/inquiry" class="main-button-group__btn">
                <v-row no-gutters align="center" justify="center">
                    <v-col cols="12" md="auto">
                        <v-img width="42" height="39" src="/images/main/icon4.svg" contain class="mx-auto" />
                    </v-col>
                    <v-col cols="12" md="auto">
                        <span class="font-size-14 font-size-md-18 mt-4px mt-md-0 ml-md-10px">캐시 내역</span>
                    </v-col>
                </v-row>
            </v-btn>
        </v-col>
    </v-row>
</template>

<script>
export default {
    mounted(){
        this.$nextTick(_ => {
            window.AOS.init({
                once:true,
            });
        });
    }
}
</script>

<style scoped>
.main-button-group{
    position: relative;
    z-index: 3;
}
.main-button-group__btn{
    position: relative;
    z-index: 1;
    -webkit-transition: all ease .6s; transition: all ease .6s;
}
.main-button-group__btn >>> .v-image {
    -webkit-transition: all ease .5s; transition: all ease .5s;
}
.main-button-group__btn:hover {
    z-index: 3;
    -webkit-transform: translateY(-10px) !important; transform: translateY(-10px) !important; box-shadow: 0px 7px 15px 0px rgba(3,34,80,.5);
}
.main-button-group__btn:hover >>> .v-image {
    transform: rotate3d(0,1,0,360deg);
}
</style>